import { useWheelSpin } from "./hooks/useWheelSpin";
import { WheelDisk } from "./components/WheelDisk";
import { WheelAction } from "./components/WheelAction";
import {
  FORTUNE_WHEEL_STEPS,
  FortuneWheelSectionItem,
} from "../../type/FortuneWheel";
import { useFortuneWheelSpinMutation } from "../../queries/useFortuneWheelSpinMutation";
import "./styles.sass";

type Props = {
  sections: FortuneWheelSectionItem[];
  nextAt: string;
  step: FORTUNE_WHEEL_STEPS;
};

export const FortuneWheel = ({ sections = [], nextAt, step }: Props) => {
  const { diskRef, angle, spin: startSpin } = useWheelSpin();

  const { mutate: requestWinner, isPending } = useFortuneWheelSpinMutation();

  const handleSpin = () => {
    startSpin();
    requestWinner();
  };

  return (
    <div className="FortuneWheel">
      <div className="FortuneWheel-screen">
        <div className="FortuneWheel-screen__coins" />
        <div className="FortuneWheel-screen-wrapper">
          <div className="FortuneWheel-screen-wrapper__back" />
          <div
            ref={diskRef}
            className="FortuneWheel-screen-wrapper-disk"
            style={{ transform: `rotate(${angle}deg)` }}
            aria-live="polite"
          >
            <WheelDisk sections={sections} />
          </div>
          <div className="FortuneWheel-screen-wrapper__pointer" />
          <div className="FortuneWheel-screen-wrapper__center" />
        </div>
        <WheelAction
          nextAt={nextAt}
          isDisabled={step === FORTUNE_WHEEL_STEPS.SPIN || isPending}
          onClick={handleSpin}
        />
      </div>
    </div>
  );
};
